import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {useQueryParam} from '../../util/react_hooks.js';
import TarotmailCustomerComp from '../../components/TarotmailCustomerComp.js';
import {withTitle} from '../../title.js';

const TarotmailCustomerDescription = ()=><Stack direction="column" gap={3}>
  <Typography variant="h6">
    ברוכים הבאים ✨
  </Typography>
  <Typography>
    עוד רגע ותיבת המייל שלך מתחילה לקבל מסר יומי אישי מהטארוט.
  </Typography>
  <Typography>
    מסר מהקלפים קצר, מדויק, שמרגיש כמה הקלפים רואים אותך, מבינים אותך, ומדברים בדיוק אל הלב שלך.
  </Typography>
  <Typography variant="h6">
    מה מחכה לך כאן?
  </Typography>
  <ul>
    <li>מסר יומי מהטארוט - ישירות למייל</li>
    <li>השראה, משמעות וריפוי - כל יום מחדש</li>
    <li>חוויה קסומה של חיבור לעצמך</li>
    <li>והתנסות עדינה עם שפת הקלפים</li>
  </ul>
  <Typography>
    כל מה שצריך לעשות עכשיו זה להשאיר שם וכתובת מייל.
  </Typography>
  <Typography>
    וזהו.
  </Typography>
  <Typography>
    עוד רגע הקסם מתחיל ✨
  </Typography>
</Stack>

const TarotmailCustomer = ()=>{
    let [id] = useQueryParam('id');
    return <Box sx={{
        // background: 'linear-gradient(45deg, rgba(255, 69, 215, 1) 0%, rgba(52, 33, 181, 1) 100%)',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
    }}>
      <TarotmailCustomerComp id={id} 
        description={<TarotmailCustomerDescription/>}/>
    </Box>;
};

export default withTitle('מסר שבועי במייל', TarotmailCustomer);
